export enum Pages {
  All = "ALL",
  About = "ABOUT",
  ActivityAreas = "ACTIVITY_AREAS",
  Blog = "BLOG",
  Contact = "CONTACT",
  Contents = "CONTENTS",
  Home = "HOME",
  TeamMember = "TEAM_MEMBER",
  TeamMembers = "TEAM_MEMBERS",
  Testimonials = "TESTIMONIALS",
}

export type PageCache = {
  images: Record<string, string>;
  links: Record<string, string>;
  texts: Record<string, string>;
};

export type WithTotalCount<T> = {
  data: T;
  total: number;
};

export type WithNavigation<T> = T & {
  nextId?: number | null;
  previousId?: number | null;
};
